var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamerant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 162 95",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.729,64.0027a36.6981,36.6981,0,0,0-26.0745-62.72H81.7577V88.3487h25.8168V74.7464h11.08c.7526,0,1.4977-.0291,2.2393-.0729l7.1584,13.6752H160ZM119.3013,47.629H107.5745V28.4006h11.7268a9.6143,9.6143,0,1,1,0,19.2284Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0855,76.3128V36.5134H50.7646v19.92H62.6887a18.7556,18.7556,0,1,1-.2655-20.3319L82.0855,16.1731v-.0388a46.469,46.469,0,1,0,0,60.6952Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamerant);
export default __webpack_public_path__ + "static/media/gamerant.57b83a1a56c74dc7d2b79796ef795dba.svg";
export { ForwardRef as ReactComponent };